import react, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";

import logo from "../../assets/Images/logo.png";

import { callAPI } from "../../assets/Js/backendCommunication";

import projectSettings from "../../assets/Js/projectSettings";

import style from "./ResetPassword.module.css";

import { passwordRegex } from "../../assets/Js/regex";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

import { Spinner } from "../Spinner/Spinner";

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ResetPassword(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const history = useHistory();
  let query = useQuery();

  const submitHandler = async (e) => {
    e.preventDefault();

    let paramEmail = query.get("email");
    let paramToken = query.get("token");
    console.log("query param email:", paramEmail);
    console.log("query param token:", paramToken);
    // validate password
    // Minimum eight characters, at least one capital letter, number and special character
    if (passwordRegex.test(password)) {
      if (password === confirmPassword) {
        resetPassword();
      } else {
        apiResponseToast(400, "resetpassword", "Passwords Do Not Match");
      }
    } else {
      apiResponseToast(
        400,
        "resetpassword",
        `Minimum 8 characters, with at least 1 capital and 1 lower letter ,
        number and special character`
      );
    }
  };

  const resetPassword = async () => {
    let url = `${projectSettings.baseUrl}/users/resetpassword`;
    let header = true;
    let type = "POST";
    let data = {};
    let token = null;

    let paramEmail = query.get("email");
    let paramToken = query.get("token");

    console.log("query param email:", paramEmail);
    console.log("query param token:", paramToken);

    data = {
      email: paramEmail,
      password: password,
      confirmPassword: confirmPassword,
      token: paramToken,
    };

    let response = "";

    if (response === "") {
      setIsLoading(true);
    }

    response = await callAPI(url, header, type, JSON.stringify(data), token);

    if (response) {
      // resetting values
      console.log("reset password Responce:", response);
      apiResponseToast(response.status, "resetpassword");

      setIsLoading(false);
      if (response.type === "error") {
        console.log("Error:", response.error);
      } else if (response.type === "success") {
        //  going to next page
        history.push({ pathname: "/login" });
      }
      response = "";
    }
  };

  return (
    <>
      <div className={style.container}>
        <div className={`${style.formContainer} shadow`}>
          <div className="logo mt-3">
            <img src={logo} className="w-100" alt="logo" />
          </div>
          <hr />
          <form className="forms-sample p-4" onSubmit={submitHandler}>
            <div className="formGroup">
              <div className="mr-1">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  className="form-control form-control-sm"
                  id="password"
                  placeholder="password"
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>
            <div className="formGroup">
              <div className="mr-1">
                <label htmlFor="password">Confirm Password</label>
                <input
                  type="password"
                  className="form-control form-control-sm"
                  id="password"
                  placeholder="password"
                  required
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </div>
            <div className="mx-auto width-fit-content mt-3">
              <button
                type="submit"
                className="basicBtnStyle primaryBtn pl-1 pr-1"
                disabled={isLoading}
              >
                {isLoading ? <Spinner /> : <span>Reset Password</span>}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="cornerBtnStyle">
        <Link to="/login" className="text-white">
          <button className="basicBtnStyle secondaryBtn">Login</button>
        </Link>
      </div>
    </>
  );
}
